import { SimpleGrid } from '@wegroup/design-system';
import React from 'react';
import { useTranslation } from 'react-i18next';
import LabeledParamFallback from '../../../../../../../../../common/src/components/label-param-fallback/LabelParamFallback';
import { toEuro } from '../../../../../../../../../sales-conversation/src/utils/stringUtils';
import useAdvisoryReportCurrency from '../../../../../hooks/useAdvisoryReportCurrency';

interface Props {
  policyNumber?: string;
  insuranceCompany?: string;
  expirationDate?: string;
  startDate?: string;
  premium?: number;
  insuredValue?: number;
  deductable?: string;
  paymentInterval?: string;
  withActions?: boolean;
  isOffer?: boolean;
  isSimulation?: boolean;
}

const InsurancePolicyHeaderParameters: React.FC<Props> = ({
  policyNumber,
  insuranceCompany,
  startDate,
  expirationDate,
  premium,
  paymentInterval,
  insuredValue,
  deductable,
  withActions,
  isOffer,
  isSimulation,
}) => {
  const { t } = useTranslation();
  const { currency } = useAdvisoryReportCurrency();

  return (
    <SimpleGrid
      gap="4"
      columns={{ base: 3, laptopL: 6 }}
      w="100%"
      // TODO: Re-enable drag and drop when BE supports it
      // ml={withActions ? '7' : undefined}
    >
      {!isOffer && (
        <LabeledParamFallback
          label={t('ADVISORY-REPORTS_CURRENT-INSURANCE_OVERVIEW_POLICY-NR')}
        >
          {policyNumber}
        </LabeledParamFallback>
      )}
      <LabeledParamFallback
        label={t(
          'ADVISORY-REPORTS_CURRENT-INSURANCE_OVERVIEW_INSURANCE-COMPANY',
        )}
      >
        {insuranceCompany}
      </LabeledParamFallback>
      {isSimulation ? (
        <LabeledParamFallback label={t('Start date')}>
          {startDate}
        </LabeledParamFallback>
      ) : (
        <LabeledParamFallback
          label={t(
            'ADVISORY-REPORTS_CURRENT-INSURANCE_OVERVIEW_EXPIRATION-DATE',
          )}
        >
          {expirationDate}
        </LabeledParamFallback>
      )}
      <LabeledParamFallback
        label={t('ADVISORY-REPORTS_CURRENT-INSURANCE_MODAL_DETAIL_OWN-RISK')}
      >
        {deductable}
      </LabeledParamFallback>
      <LabeledParamFallback
        label={t(
          'ADVISORY-REPORTS_CURRENT-INSURANCE_MODAL_DETAIL_INSURED-VALUE',
        )}
      >
        {insuredValue && toEuro(insuredValue, currency)}
      </LabeledParamFallback>
      <LabeledParamFallback
        label={t('ADVISORY-REPORTS_CURRENT-INSURANCE_OVERVIEW_PREMIUM')}
      >
        {premium && paymentInterval
          ? `${toEuro(premium, currency)} / ${t(paymentInterval)}`
          : premium
          ? toEuro(premium, currency)
          : undefined}
      </LabeledParamFallback>
    </SimpleGrid>
  );
};

export default InsurancePolicyHeaderParameters;
